import { Component, OnInit } from '@angular/core';

import { DialogImage, DialogService, ImageDialogComponent, ImageDialogData } from '@mitsubishi/ui/dialog';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-image-type',
  templateUrl: './image-type.component.html',
  styleUrls: ['./image-type.component.scss'],
  standalone: false,
})
export class ImageTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  isGallery = false;
  isUrl = false;

  constructor(private dialogService: DialogService) {
    super();
  }

  ngOnInit() {
    this.isGallery = this.field.parent?.wrappers?.some(wrapper => wrapper === 'gallery') || false;
    this.isUrl = this.checkValueIsURL();
  }

  checkValueIsURL() {
    try {
      new URL(this.field.defaultValue);
      return true;
    } catch (e) {
      return false;
    }
  }

  toggleFullScreen() {
    const images: DialogImage[] = [
      {
        url: this.isUrl ? this.field.defaultValue : undefined,
        base64: !this.isUrl ? 'data:image/png;base64,' + this.field.defaultValue : undefined,
      },
    ];

    if (this.field.props?.compareValue) {
      images.push({
        url: this.isUrl ? this.field.props?.compareValue : undefined,
        base64: !this.isUrl ? 'data:image/png;base64,' + this.field.props?.compareValue : undefined,
      });
    }

    const data: ImageDialogData = {
      title: this.field.props?.label,
      images: images,
    };
    this.dialogService.openDialogScroll(ImageDialogComponent, 'xl', data);
  }
}
